import { DetailAction } from '../../detail/actions/DetailAction';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';
import { FilterState, listFilterType } from '../../../pages/content/listPage/FilterState';
import { Backend } from '../../../api/Backend';
import { OptionData } from '../../../components/option/OptionData';
import { ICategoryV5 } from '../../../api/models/AndromeTV.types';
import { EpgApiV5 } from '../../../api/EpgApiV5';

export class ListTagFilterActionHandler extends DetailAction {
  private filterState: FilterState;

  constructor(backend: Backend, filterState: FilterState) {
    super(backend);
    this.filterState = filterState;
  }

  override doAction() {
    EpgApiV5.categories(this._backend).then(data => {
      const filteredData = this.removeAdult(data);
      const selected = this.filterState.stateOf(listFilterType.tag);
      const options = filteredData?.map(cat => this._optionFromCategory([], cat, selected));

      this.owner?.fireAncestors('$openDialog', {
        type: SelectOptionDialog,
        params: {
          backend: this._backend,
          options: options,
          onSuccess: (val: OptionData) => {
            this.optionSelected(val);
          },
          onCancelled: this.hideOptions.bind(this),
        },
      });
    });
  }

  _optionFromCategory(parentTags: string[], cat: ICategoryV5, selected: OptionData) {
    const result: OptionData = { options: [], value: undefined };
    const hasChildren = cat.categories && cat.categories.length > 0;
    const postfix = hasChildren ? ' >' : '';
    result.text = cat.text.title + postfix;
    result.selected = selected && selected.value.includes(cat.tag);
    result.value = [...parentTags, cat.tag];
    if (hasChildren) {
      result.options = cat.categories?.map(c => this._optionFromCategory(result.value, c, selected)) || [];
    }
    return result;
  }

  optionSelected(option: OptionData) {
    this.filterState.updateState(listFilterType.tag, option.text, option.value);
    this.hideOptions();
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }

  removeAdult(itemsArr: ICategoryV5[] = []): ICategoryV5[] {
    if (!itemsArr) return [];

    return itemsArr
      .map(item => {
        if (item.adult) return undefined;
        item.categories = this.removeAdult(item.categories);
        return item;
      })
      .filter(el => el) as ICategoryV5[];
  }
}
